import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/money/receiptissue/`;

const getAdminList = async () => {
    return await axios.get(`${BACKEND_URL}/api/setting/admin`);
};

const getIncompleteIssue = async ({ page = 1, limit = 20, admin = '' } = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (admin) params.append('admin', admin);
    return await axios.get(`${API_URL}incomplete?${params.toString()}`);
};

const updateDoneStatus = async (id) => {
    return await axios.post(API_URL+'done', id);
};

export default {
    getAdminList,
    getIncompleteIssue,
    updateDoneStatus
};
